import { createContext, ReactNode, useCallback, useContext, useState } from 'react';

import { IUser } from '@/features/user/store/user.model';
import { TMetadata } from '@/store/models/generics.model';

export interface IProfileContext {
  user: IUser;
  metadata: TMetadata;
  updateMetadata: (newData: TMetadata) => void;
}

export const ProfileContext = createContext<IProfileContext>({} as IProfileContext);

interface IProfileProvider {
  children: ReactNode;
  user: IUser;
}

export const ProfileProvider = ({ children, user }: IProfileProvider) => {
  const [metadata, setMetadata] = useState<TMetadata>({});

  const handleUpdateMetadata = useCallback(
    (newData) => {
      setMetadata((oldData) => ({ ...oldData, ...newData }));
    },
    [setMetadata],
  );

  return (
    <ProfileContext.Provider
      value={{
        user,
        metadata,
        updateMetadata: handleUpdateMetadata,
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};

export const useProfileContext = () => useContext(ProfileContext);
